import DataGrid, {
  Column,
  Pager,
  Paging,
  FilterRow,
  Lookup,
} from "devextreme-react/data-grid";
import Button from "devextreme-react/button";
import React, { useState, useEffect } from "react";
import { useAuth } from "../../contexts/auth";
import axios from "axios";
import { backendlink } from "../../config";

export default function PartnerEcgDeviceListDatagrid({ fetchTrigger }) {
  const { user } = useAuth();

  const [ecgDeviceList, setEcgDeviceList] = useState([]);

  const onExport = async (e) => {
    var currentDate = new Date();
    var currentDateString =
      currentDate.getFullYear() +
      (currentDate.getMonth() + 1 < 10
        ? "0" + (currentDate.getMonth() + 1)
        : currentDate.getMonth() + 1) +
      (currentDate.getDate() < 10
        ? "0" + currentDate.getDate()
        : currentDate.getDate());
    var fileName = "vitopro_EcgDeviceList_" + currentDateString;

    try {
      const response = await axios
        .get(backendlink + "partner/getecgdeviceexportlist", {
          headers: {
            token: user.token,
          },
          params: {
            distributorToken: user.userToken,
            ecgDeviceList: ecgDeviceList,
          },
          responseType: "blob",
        })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName + ".xlsx");
          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        });
    } catch (error) {
      console.log(error);
      alert(error);
    }
  };

  useEffect(() => {
    const fetchData = async (loadOptions) => {
      try {
        const page = Math.floor(loadOptions.skip / loadOptions.take) + 1;
        const size = loadOptions.take;
        const response = await axios.get(
          backendlink + "partner/getdistecgdevices",
          {
            headers: {
              token: user.token,
            },
            params: {
              page: page,
              size: size,
              distributorToken: user.userToken,
            },
          }
        );

        if (response.data.errorno === 0) {
          const outputArray = response.data.result.map((item) => {
            return {
              serialNo: item.serialNo,
              contractNo: item.contractNo,
              organizationName: item.organizationName,
              patientName: item.patientName,
              expiryDate: item.expiryDate,
              status: item.status,
            };
          });
          setEcgDeviceList(outputArray);
        } else {
          setEcgDeviceList([]);
          alert(response.data.errmessage);
        }
      } catch (error) {
        alert(error);
      }
    };

    fetchData({ skip: 0, take: 5 });
  }, [user, fetchTrigger]);

  return (
    <div>
    <React.Fragment>
      <DataGrid dataSource={ecgDeviceList}>
        <Column dataField="serialNo" caption="Device Id" alignment="left" />
        <Column dataField="contractNo" caption="Contract No" />
        <Column dataField="organizationName" caption="Assigned Organization" />
        <Column dataField="patientName" caption="Assigned Patient" />
        <Column dataField="expiryDate" caption="Expiry Date" />
        <Column dataField="status" caption="Status" />

        <Pager allowedPageSizes={[5, 10, 20]} showPageSizeSelector={true} />
        <Paging defaultPageSize={5} />
        <FilterRow visible={true} />
        <Lookup />
      </DataGrid>
      <Button
          type="default"
          text="Export"
          onClick={() => {
            onExport();
          }}
          style={{ width: "20%", marginTop: "40px" }}
        />
    </React.Fragment>
    </div>
  );
}